import { FC } from 'react';

import { DatePicker, Select } from 'antd';
import { Form, Input } from 'ui';

import { EventTicketType } from 'types/events/eventTypes';

import s from './OrdersHeader.module.scss';

const { RangePicker } = DatePicker;

// typescript-eslint-disable @typescript-eslint/no-implicit-any
// typescript-eslint-disable @typescript-eslint/no-implicit-any
type RangeValue = any;

interface OrdersHeaderProps {
  onRangeChange: (dates: RangeValue, formatString: [string, string], info: { range?: any }) => void;
  ticketTypes?: EventTicketType[];
  rangePickerValue?: any;
}

const OrdersHeader: FC<OrdersHeaderProps> = ({ onRangeChange, ticketTypes, rangePickerValue }) => {
  const handleRangePickerChange = () => {};

  const ticketOptions = ticketTypes?.map((ticket) => ({
    value: ticket?.id,
    label: ticket?.name,
  }));

  return (
    <div className={s.header}>
      <div className={s.searchBlock}>
        <Form.Item name="filter" className={s.range}>
          <Input
            name="filter"
            placeholder="Order or receipt number, seller or buyer"
            icon="search"
            fullWidth
          />
        </Form.Item>
      </div>
      <div className={s.sortBlock}>
        <Form.Item name="TicketTypeIds">
          <Select
            mode="multiple"
            allowClear
            showSearch
            size="large"
            placeholder="Select ticket types"
            options={ticketOptions}
            filterOption={(input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
          />
        </Form.Item>
        <Form.Item name="SortByColumn">
          <Select
            allowClear={true}
            options={[
              { value: 'byDate', label: 'Date' },
              { value: 'byEmail', label: 'E-mail' },
            ]}
            placeholder="Select sort column"
            size="large"
          />
        </Form.Item>

        <Form.Item name="SortType" style={{ width: '100%' }}>
          <Select
            allowClear={true}
            options={[
              { value: 'ascending', label: 'Ascending' },
              { value: 'descending', label: 'Descending' },
            ]}
            placeholder="Select sort type"
            size="large"
          />
        </Form.Item>
        <Form.Item name="IncludeRefunds" style={{ width: '100%' }}>
          <Select
            allowClear={true}
            options={[
              { value: true, label: 'Yes' },
              { value: false, label: 'No' },
            ]}
            placeholder="Include refunds"
            size="large"
          />
        </Form.Item>

        <RangePicker
          value={rangePickerValue}
          onOpenChange={handleRangePickerChange}
          onCalendarChange={onRangeChange}
          className={s.rangePicker}
        />
      </div>
    </div>
  );
};

export default OrdersHeader;
